import JSZip from 'jszip';
import { saveAs } from 'file-saver';

export default class ZipFile {
  constructor(params) {
    this.zip = new JSZip();
    this.assetID = params.gateway._id;
    this.certificate = params.certificate;
    this.privateKey = params.privateKey;
  }
  createFileNames() {
    this.certificateFile = `${this.assetID}.crt`;
    this.privateKeyFile = `${this.assetID}.key`;
    this.downloadFileName = `${this.assetID}-certificate.zip`;
    return this;
  }
  queueZipFiles() {
    this.zip.file(this.certificateFile, this.certificate);
    this.zip.file(this.privateKeyFile, this.privateKey);
    return this;
  }
  async generateZipFile() {
    this.zipFileBlob = await this.zip.generateAsync({ type: 'blob' });
    return this;
  }
  downloadZipFile = () => {
    saveAs(this.zipFileBlob, this.downloadFileName);
  };
}
